// extracted by mini-css-extract-plugin
export default {"tabsContainer":"partners_tabsContainer__36OsH","tabButton":"partners_tabButton__qxlKT","active":"partners_active__s8Y9Q"};